import { FC } from 'react'
import { Space } from 'antd-mobile'
import { useTranslation } from "react-i18next";
import css from './index.module.less';

export const ShowPage: FC = () => {
  const { t } = useTranslation();

  return (
    <Space className={css.PageLoading} align={'center'} justify={'center'}><div dangerouslySetInnerHTML={{ __html: t('question.status') }}></div></Space>
  )
}

